<!-- eslint-disable vue/valid-v-for -->
<template>
    <v-layout class="sistema-template">
        <v-navigation-drawer v-model="drawer_open" fixed app :width="300" class="navigation">
            <img class="logo-menu" :src="logo" alt="Logo Rodobens" />
            <h2 class="mx-6 mb-n2" style="font-size: 1.5rem;color: var(--primary);">Painel Administrativo</h2>
            <v-divider class="my-5 mx-5" style="border-width: 1px;"></v-divider>
            <div class="ml-5">
                <div>
                    <v-row>
                        <v-col cols="2" class="d-flex align-start justify-center">
                            <v-icon style="margin-top: 2px">mdi-office-building-outline</v-icon>
                        </v-col>
                        <v-col cols="10" style="word-break: break-word;">
                            <h5 class="text-xs text-uppercase">{{ nome }}</h5>
                            <p>
                                <span class="text-uppercase">{{ nomePerfilAdmin }}</span>
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-divider class="my-5 mt-0 mx-5" style="border-width: 1px;"></v-divider>
            <v-list>
                <template v-for="(item, i) in menu">
                    <v-list-item v-if="!item.menuPai" :key="i" class="icon_menu" :class="[item.selected ? 'selected' : null]" @click="acessar(item)">
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.text.toUpperCase() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-group
                            v-if="item.menuPai"
                            :key="i"
                            :value="item.selected"
                            class="w-100 icon_menu d-flex justify-center flex-column group-menu-pai"
                            no-action
                    >
                        <template v-slot:prependIcon>
                            <div class="d-flex mr-2">
                                <v-icon v-text="item.icon"></v-icon>
                            </div>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-title class="text-uppercase">{{ item.text }}</v-list-item-title>
                        </template>
                        <template v-for="(submenus, j) in subMenus">
                            <template v-if="submenus[0].pai !== 'Plataforma de Vendas' && item.text === submenus[0].pai">
                                <v-list-item
                                        :key="j"
                                        :style="{
                                            margin: 4 + 'px',
                                            height: 40 + 'px',
                                            outline: 'none',
                                            border: 'none'
                                        }"
                                        v-for="(submenu) in submenus"
                                        class="pt-0 pl-6 icon_menu"
                                        :class="[submenu.selected ? 'selected' : null]"
                                        @click="acessar(submenu)"
                                        link
                                >
                                    <v-list-item-action>
                                        <v-icon>{{ submenu.icon }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ submenu.text.toUpperCase() }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <template v-if="submenus[0].pai === 'Plataforma de Vendas' && item.text === submenus[0].pai">
                                <v-list-item
                                        :key="j"
                                        :style="{
                                            margin: 4 + 'px',
                                            height: 40 + 'px',
                                            outline: 'none',
                                            border: 'none'
                                        }"
                                        v-for="(item) in linksFlavors"
                                        class="icon_menu pt-0"
                                        @click="redirect(item.url)"
                                >
                                    <v-list-item-action>
                                        <v-icon>mdi-open-in-new</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ item.nome_amigavel }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </template>
                    </v-list-group>
                </template>
            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <div style="margin-top: auto" class="text-center dark--text font-subtitle-1 font-weight-bold">
                        {{ appVersion }}
                    </div>
                </div>
            </template>
        </v-navigation-drawer>
        <v-content class="app-content">
            <BarraSuperior v-model="drawer_open" :painel="true" :nome="nome" @logout="logoutAdmin" />
            <router-view class="router-view" :key="$route.path"></router-view>
        </v-content>
        <DialogAtualizacaoDaVersao v-model="dialogAtualizacaoVersao" />
    </v-layout>
</template>

<script>
  import { flavorRes } from '@/plugins/flavors'
  import { NivelPermissoesPerfil, PerfisAdmin } from '@/plugins/constants'
  import { mapMutations, mapState } from 'vuex'
  import { obterNomePerfilPorId } from '../../plugins/painel_helpers'
  import BarraSuperior from '../../components/sistema/BarraSuperior.vue'
  import { alert } from '../../plugins/helpers'
  import DialogAtualizacaoDaVersao from '../../dialogs/atualizacao/DialogAtualizacaoDaVersao.vue'

  var subMenusTemp = []
  export default {
    name: 'Painel',
    components: { BarraSuperior, DialogAtualizacaoDaVersao },
    data: () => ({
      appVersion: process.env.VUE_APP_VERSION,
      drawer: true,
      estiloSubMenu: {
        padding: '0px -8px 0px -8px',
        margin: '-4px -8px -4px -8px',
        border: 'none !important',
        boxShadow: 'none !important',
        left: 'none !important',
        borderRadius: '0',
        overflow: 'hidden',
        fontSize: '24px !important'
      },
      item_clicado: 1,
      menu: [],
      subMenus: [],
      linksFlavors: [],
      dialogAtualizacaoVersao: false,
      nomePerfilAdmin: 'Carregando...'
    }),
    computed: {
      ...mapState(['perfil_adm']),
      drawer_open: {
        get () {
          return this.drawer
        },
        set (val) {
          this.drawer = val
        }
      },
      logo: () => flavorRes('img/logo-menu.png'),
      nome () {
        return this.$session.get('nome') || ''
      }
    },
    watch: {
      $route: async function (to, from) {
        await this.getMenuItems()
      }
    },
    async mounted () {
      await this.carregarNomePerfil()
      this.getMenuItems()
      this.getLinksFlavors()
      if (!this.$session.get('admin')) {
        this.$router.replace('/painel/logout')
      }
    },
    methods: {
      ...mapMutations(['setAccess']),
      redirect (url) {
        const login = this.$session.get('login')
        const _s = this.$session.get('_s')
        const sessao_painel = this.$session.get('sessao_painel')
        const vendas_backoffice = this.$session.get('vendas_backoffice')

        this.setAccess({ login, _s, sessao_painel, vendas_backoffice })

        const params = { login: login, senha: _s, origem_painel: true }
        const queryString = Object.keys(params)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
          .join('&')

        if (url === 'localhost:8080') {
          window.open('http://' + url + '/Sistema/#/login?' + queryString)
        } else {
          window.open('https://' + url + '/Sistema/#/login?' + queryString)
        }
      },
      async carregarNomePerfil () {
        if (this.perfil_adm) {
          this.nomePerfilAdmin = await obterNomePerfilPorId(this.perfil_adm, this.$http)
        }
      },
      getLinksFlavors () {
        this.$http.get('/painel/flavors/get-all').then(response => {
          this.linksFlavors = response.data
        })
      },
      getSubMenus (id_funcionalidade, permissao, nivelPermissao) {
        const links = [
          {
            order: 2,
            icon: 'mdi-file-cog',
            id_funcionalidade: 20,
            ...this.menuRoute('cadastro-tipo-cota'),
            pai: 'Cadastros'
          },
          {
            order: 1,
            icon: 'mdi-store-cog',
            id_funcionalidade: 19,
            ...this.menuRoute('cadastro-unidade-negocio'),
            pai: 'Cadastros'
          },
          {
            order: 3,
            icon: 'mdi-store-cog',
            id_funcionalidade: 24,
            ...this.menuRoute('cadastro-produtos'),
            pai: 'Cadastros'
          },
          {
            order: 1,
            icon: 'mdi-file-chart',
            id_funcionalidade: 10,
            ...this.menuRoute('relatorios-vendas'),
            pai: 'Relatórios'
          },
          {
            order: 2,
            icon: 'mdi-file-chart',
            id_funcionalidade: 23,
            ...this.menuRoute('relatorios-politica-vendas'),
            pai: 'Relatórios'
          },
          {
            order: 3,
            icon: 'mdi-file-chart',
            id_funcionalidade: 11,
            ...this.menuRoute('relatorios-erros'),
            pai: 'Relatórios'
          },
          {
            order: 4,
            icon: 'mdi-file-chart',
            id_funcionalidade: 22,
            ...this.menuRoute('relatorios-expurgos-propostas'),
            pai: 'Relatórios'
          },
          {
            order: 5,
            icon: 'mdi-file-chart',
            id_funcionalidade: 25,
            ...this.menuRoute('relatorios-expurgos-logs'),
            pai: 'Relatórios'
          },
          {
            order: 1,
            icon: 'rod-politica-vendas',
            id_funcionalidade: 5,
            ...this.menuRoute('importa-politica'),
            pai: 'Produtos e grupos'
          },
          {
            order: 2,
            icon: 'mdi-briefcase-edit',
            id_funcionalidade: 6,
            ...this.menuRoute('regra-furo'),
            pai: 'Produtos e grupos'
          },
          {
            order: 1,
            icon: 'mdi-cogs',
            id_funcionalidade: 17,
            ...this.menuRoute('config-analise-credito'),
            pai: 'Análise de crédito',
            onlyManager: true
          },
          {
            order: 2,
            icon: 'mdi-file-chart',
            id_funcionalidade: 18,
            ...this.menuRoute('analise-credito-relatorio-consultas'),
            pai: 'Análise de crédito'
          },
          {
            order: 1,
            icon: 'mdi-cogs',
            id_funcionalidade: 21,
            ...this.menuRoute('configuracoes-carrinho'),
            pai: 'Carrinho de Compras'
          },
          {
            order: 2,
            icon: 'mdi-briefcase-edit',
            id_funcionalidade: 16,
            ...this.menuRoute('linkplataforma-rodobens'),
            pai: 'Plataforma de Vendas'
          },
          {
            order: 1,
            icon: 'mdi-cogs',
            id_funcionalidade: 27,
            ...this.menuRoute('broker'),
            pai: 'Broker'
          }
        ]
        let linksEscolhidos = []
        links.forEach(link => {
          if (link.id_funcionalidade === id_funcionalidade && this.getPermissaoByNivelPermissao(link.onlyManager, permissao, nivelPermissao)) {
            linksEscolhidos = [...linksEscolhidos, link]
          }
        })
        linksEscolhidos.sort((a, b) => a.order - b.order)
        linksEscolhidos.forEach(linkEscolhido => {
          subMenusTemp.push(linkEscolhido)
        })
      },
      async getMenuItems () {
        subMenusTemp = []
        let menu = []
        let login = this.$session.get('login')

        const { permissao, nivelPermissaoPerfil } = await this.$http
          .get(`/painel/backoffice/autenticar-usuario/${login}`)
          .then((response) => {
            return {
              permissao: response.data.perfil_adm,
              nivelPermissaoPerfil: response.data.permissao_perfil_adm
            }
          })

        const permissoesPerfil = this.$session.get('funcionalidades_permitidas') || []

        const links = [
          {
            order: 1,
            icon: 'cloud_download',
            id_funcionalidade: [1],
            ...this.menuRoute('painel-sincronizacao')
          },
          {
            order: 2,
            icon: 'mdi-file-import',
            id_funcionalidade: [2],
            ...this.menuRoute('importa-proposta')
          },
          {
            order: 3,
            icon: 'mdi-autorenew',
            id_funcionalidade: [3],
            ...this.menuRoute('log-sincronizacao')
          },
          {
            order: 4,
            icon: 'mdi-file-document-edit-outline',
            id_funcionalidade: [4],
            ...this.menuRoute('contratos')
          },
          {
            order: 5,
            menuPai: true,
            icon: 'mdi-notebook-outline',
            id_funcionalidade: [5, 6],
            ...this.menuRoute('submenuProdutosGrupos')
          },
          {
            order: 6,
            icon: 'mdi-account-group',
            id_funcionalidade: [7],
            ...this.menuRoute('grupos-financiamento')
          },
          {
            order: 7,
            icon: 'mdi-store',
            id_funcionalidade: [8],
            ...this.menuRoute('grupo-vendas')
          },
          {
            order: 8,
            icon: 'mdi-cogs',
            id_funcionalidade: [9],
            ...this.menuRoute('configuracao-pagamento')
          },
          {
            order: 9,
            menuPai: true,
            icon: 'mdi-file-chart',
            id_funcionalidade: [10, 11, 22, 23, 25],
            ...this.menuRoute('submenuRelatorio')
          },
          {
            order: 10,
            icon: 'mdi-book-open-page-variant',
            id_funcionalidade: [12],
            ...this.menuRoute('auditoria')
          },
          {
            order: 11,
            icon: 'mdi-hand-pointing-right',
            id_funcionalidade: [13],
            ...this.menuRoute('gerenciamento-terceiros')
          },
          {
            order: 12,
            icon: 'mdi-security',
            id_funcionalidade: [14],
            ...this.menuRoute('usuarios-config')
          },
          {
            order: 13,
            menuPai: true,
            icon: 'mdi-book-cog',
            id_funcionalidade: [19, 20, 24],
            ...this.menuRoute('submenuCadastros')
          },
          {
            order: 14,
            icon: 'mdi-format-paint',
            id_funcionalidade: [15],
            ...this.menuRoute('flavor-config')
          },
          {
            order: 15,
            menuPai: true,
            icon: 'mdi-web',
            id_funcionalidade: [16],
            ...this.menuRoute('submenuPlataformaVendas')
          },
          {
            order: 16,
            menuPai: true,
            icon: 'mdi-file-search',
            id_funcionalidade: [17, 18],
            ...this.menuRoute('subMenuAnaliseCredito')
          },
          {
            order: 17,
            menuPai: true,
            icon: 'mdi-cart',
            id_funcionalidade: [21],
            ...this.menuRoute('submenuCarrinho')
          },
          {
            order: 18,
            menuPai: true,
            icon: 'mdi-sitemap',
            id_funcionalidade: [27],
            ...this.menuRoute('submenuBroker')
          }
        ]

        // Filtrando os menus com base nas permissões
        links.forEach((link) => {
           const idsPermitidos = link.id_funcionalidade.filter(id => permissoesPerfil.includes(id))
          // Verifica se pelo menos um ID de funcionalidade está presente nas permissões
          if (
            idsPermitidos.length > 0 &&
            this.getPermissaoByNivelPermissao(
              link.onlyManager,
              permissao,
              nivelPermissaoPerfil
            )
          ) {
            menu.push(link)

            // Adicionando submenus, se necessário
            if (link.menuPai) {
              idsPermitidos.forEach((id) => {
                this.getSubMenus(id, permissao, nivelPermissaoPerfil)
              })
            }
          }
        })

        // Ordenando menus
        menu.sort((a, b) => a.order - b.order)
        this.menu = menu

        // Ordenando submenus temporários
        subMenusTemp.sort((a, b) => a.order - b.order)

        // Agrupando submenus por categorias
        let submenu = []
        let SubMenuRelatorio = []
        let SubMenuProdEGrupo = []
        let SubMenuPlatVenda = []
        let SubMenuCreditAnalysis = []
        let SubMenuCadastros = []
        let SubMenuCarrinho = []
        let SubMenuBroker = []
        let temp = subMenusTemp

        temp.forEach((subMenu) => {
          switch (subMenu.pai) {
            case 'Relatórios':
              SubMenuRelatorio.push(subMenu)
              break
            case 'Produtos e grupos':
              SubMenuProdEGrupo.push(subMenu)
              break
            case 'Plataforma de Vendas':
              SubMenuPlatVenda.push(subMenu)
              break
            case 'Análise de crédito':
              SubMenuCreditAnalysis.push(subMenu)
              break
            case 'Cadastros':
              SubMenuCadastros.push(subMenu)
              break
            case 'Carrinho de Compras':
              SubMenuCarrinho.push(subMenu)
              break
            case 'Broker':
              SubMenuBroker.push(subMenu)
          }
        })

        if (SubMenuRelatorio.length !== 0) {
          submenu.push(SubMenuRelatorio)
        }

        if (SubMenuProdEGrupo.length !== 0) {
          submenu.push(SubMenuProdEGrupo)
        }

        if (SubMenuCreditAnalysis.length !== 0) {
          submenu.push(SubMenuCreditAnalysis)
        }
        if (SubMenuCadastros.length !== 0) {
          submenu.push(SubMenuCadastros)
        }
        if (SubMenuPlatVenda.length !== 0) {
          submenu.push(SubMenuPlatVenda)
        }
        if (SubMenuCarrinho.length !== 0) {
          submenu.push(SubMenuCarrinho)
        }
        if (SubMenuBroker.length !== 0) {
          submenu.push(SubMenuBroker)
        }

        this.subMenus = submenu
      },
      getPermissaoByNivelPermissao (onlyForManager, permissao, nivelPermissao) {
        if (onlyForManager && permissao === PerfisAdmin.Credito.id_banco && nivelPermissao !== NivelPermissoesPerfil.Gerente.id_banco) {
          return false
        } else {
          return true
        }
      },
      logoutAdmin () {
        alert({
          text: 'Tem certeza que deseja sair do sistema?',
          buttons: {
            Cancelar: () => true,
            Confirmar: () => this.$router.replace('/painel/logout')
          }
        })
      },
      acessar (item) {
        if (item.click) {
          item.click()
        } else {
          try {
            this.$router.push(item.to)
          } catch (e) {
            return false
          }
        }
        this.item_clicado = item.id_funcionalidade
      },
      menuRoute (name) {
        // Para adicionar os nomes dos subMenus, vá adicionando aqui, retornando o nome do SubMenu

        if (name === 'submenuRelatorio') {
          return { text: 'Relatórios' }
        } else if (name === 'submenuProdutosGrupos') {
          return { text: 'Produtos e grupos' }
        } else if (name === 'submenuPlataformaVendas') {
          return { text: 'Plataforma de Vendas' }
        } else if (name === 'subMenuAnaliseCredito') {
          return { text: 'Análise de crédito' }
        } else if (name === 'submenuCadastros') {
          return { text: 'Cadastros' }
        } else if (name === 'submenuCarrinho') {
          return { text: 'Carrinho de Compras' }
        } else if (name === 'submenuBroker') {
          return { text: 'Broker' }
        }
        try {
          const route = this.$router.resolve({ name }).route
          const selected = this.$route.path.startsWith(route.path)
          return route.matched.length ? { text: route.meta.title, to: route.path, selected } : { text: '// fixme' }
        } catch (e) {
          return false
        }
      }
    }
  }
</script>

<style scoped>

.texto24px {
    font-size: 24px !important;
}

</style>

<style>
.group-menu-pai .v-list-item .v-list-item__icon{
    margin-right: 8px;
    height: auto;
    box-sizing: border-box;
    position: relative;
    align-self: center !important;

}
.group-menu-pai {
    position: relative;

}

.group-menu-pai::before {
    content: '';
    position: absolute;
    top: 0;
    left: 16px;
    right: 16px;
    height: 0.09rem;
    background-color: #bbb;
}
</style>
